module.exports = __webpack_public_path__ + "static/media/module.a27827c8.png";